import { render, staticRenderFns } from "./base-table-one.vue?vue&type=template&id=a64178c2&scoped=true&"
import script from "./base-table-one.vue?vue&type=script&lang=js&"
export * from "./base-table-one.vue?vue&type=script&lang=js&"
import style0 from "./base-table-one.vue?vue&type=style&index=0&id=a64178c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a64178c2",
  null
  
)

export default component.exports